import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';
import { PageHeader } from '@/components/shared/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CouponsTab } from './coupons-tab';
import { PlansTab } from './plans-tab';
import { ProgramTab } from './program-tab';

const TABS = ['programa', 'planos', 'cupons'] as const;

export function LoyaltyPage() {
  const [state, setState] = useQueryStates(
    { aba: parseAsStringLiteral(TABS).withDefault('programa'), page: parseAsInteger, q: parseAsString, sort: parseAsString, order: parseAsString },
    { history: 'replace' },
  );
  return (
    <div>
      <PageHeader title="Fidelidade e planos" description="Programa de pontos, pacotes, mensalidades e cupons de desconto." />
      <Tabs value={state.aba} onValueChange={(v) => setState({ aba: v as (typeof TABS)[number], page: null, q: null, sort: null, order: null })}>
        <TabsList>
          <TabsTrigger value="programa">Programa</TabsTrigger>
          <TabsTrigger value="planos">Planos e pacotes</TabsTrigger>
          <TabsTrigger value="cupons">Cupons</TabsTrigger>
        </TabsList>
        <TabsContent value="programa" className="mt-5">
          <ProgramTab />
        </TabsContent>
        <TabsContent value="planos" className="mt-5">
          <PlansTab />
        </TabsContent>
        <TabsContent value="cupons" className="mt-5">
          <CouponsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
